<!-- Informes EXPEDIENTES VALORACION -->

<template>
  <div class="expValReport" v-if="loaded">

    <div style="display:flex;justify-content:center">
      <v-sheet :elevation="4">

        <!-- Cabecera -->
        <div class="cabecera">
          <baseHeader
            :cfg="$cfe.headers.finder"
            :titulo='$store.state[storeName].titulo'
            @onEvent="eventHeader">
          </baseHeader>
        </div>


        <!-- Botonera -->
        <div class="pt-2 pl-2">
          <baseBtraExtra class="conflex"
            :permExtra="permExtra"
            :modulo="btExtCfg"
            @onEvent="execAccion">
          </baseBtraExtra>
        </div>

        <!-- Contenido -->
        <div class="contenedor" style="width:950px">
          <div class="conflex">
            <div class="columna" style="width:32%">

              <!-- Menú -->
              <div class="cab">Tipos de Informes</div>
              <v-sheet v-bind="$cfg.styles.marco">
                <v-treeview
                  :items="recordsRead[0]"
                  item-key="d"
                  item-text="n"
                  item-children="c"
                  activatable
                  dense
                  open-on-click
                  open-all
                  :active="informe"
                  return-object
                  @update:active="changeInf">
                </v-treeview>
              </v-sheet>
            </div>

            <div class="columna" style="width:66%;margin-left:10px">
              <div class="cab">Condiciones</div>

              <v-sheet v-bind="$cfg.styles.marco">
                <!-- Ordenado -->
                <div style="display:flex">
                    <v-select
                        style="flex: 0 0 60%"
                        v-bind="$select"
                        v-model="ct.ord[2]"
                        :label="ct.ord[1]"
                        :items="ord"
                        item-value="d"
                        item-text="n">
                    </v-select>
                </div>

                <!-- Tipo Servicio, Estado -->
                <div style="display:flex">
                    <v-select
                        style="flex: 0 0 60%"
                        v-bind="$select"
                        v-model="ct.tip[2]"
                        :label="ct.tip[1]"
                        :items="recordsRead[2]"
                        item-value="d"
                        item-text="n">
                    </v-select>
                    <v-select
                        style="flex: 0 0 40%"
                        v-bind="$select"
                        v-model="ct.std[2]"
                        :label="ct.std[1]"
                        :items="recordsRead[3]"
                        item-value="d"
                        item-text="n">
                    </v-select>
                </div>

                <!-- Periodo Fechas -->
                <div style="display:flex">
                  <uiMultiFilterFechas
                    style="width:100%"
                    :items="recordsRead[4]"
                    :ct="ct"
                    :ctrl="ct.fecha"
                    tipo="periodo"
                    >
                  </uiMultiFilterFechas>
                </div>

                <!-- Jefe zona (COS) -->
                <div style="display:flex">
                    <v-select
                      style="flex: 0 0 100%"
                        v-bind="$select"
                        v-model="ct.zona[2]"
                        :label="ct.zona[1]"
                        :items="itemsZonas"
                        item-value="id"
                        item-text="name"
                        :disabled="zona>0 || ct.apd[2]>''">
                    </v-select>
                </div>

                 <!-- APD, Centro Tramitador -->
                <div style="display:flex">
                    <ctrlF style="flex: 0 0 100%" :ct="ct.apd" :disabled="ct.zona[2]>'0'"></ctrlF>
                </div>

                <!-- Funeraria -->
                <div style="display:flex">
                    <ctrlF style="flex: 0 0 100%" :ct="ct.fun"></ctrlF>
                </div>

              </v-sheet>
            </div>
          </div>
        </div>
      </v-sheet>
    </div>
  </div>
</template>


<script>

  import { mixR } from "@/mixins/mixR.js";
  import baseHeader from "@/base/baseHeader";
  import baseBtraExtra from "@/base/baseBtraExtra";

  export default {
    mixins: [mixR],
    components: { baseHeader, baseBtraExtra },
    props: {},

    data() {
      return {
        stIni: {
          api: "expValR",
          titulo:"·Informe EXPEDIENTES VALORACIÓN",
          name:"expValR",
          mView:'',
          pView:[]
        },
        informe:[],

        ord: [],
        itemsZonas:[],

      };
    },

    methods: {
      iniDataParticular() {
        console.log("DEV " + this.stIni.api + " ********************** (iniDataParticular)",this.recordsRead);

        this.btExtCfg.btnsAccion= [
          { accion:'verPdf', btn:"pdf" },
          { accion:'verExcel', btn:"excel" }
        ];

        // coordinadores de servicio
        this.itemsZonas= this.$store.state.datos_iniciales.zonas.slice();
        this.itemsZonas.unshift({id:'0',name:'( Selecciona )'});

        // asigno zona recibida
        this.$set(this.ct.zona, 2, this.zona);

        //omision
        /* this.ct.estado[2]='0';
        this.ct.tipo_ori[2]=1;
        this.ct.tipo_emp[2]=1;
        this.ct.tipo_zon[2]='3'; */

      },

      // si cambia cuenta en uimultiple
      changeCta(evt) {
          console.log('changeCta',evt);
          //if (!evt[4].comp) return;
      },

      // verPdf,verExcel,showReport en mixR

      stRecordsGetFin() {
        let x=JSON.parse(JSON.stringify(this.recordsRead[0][0].c));
        //console.log('++++++',x);

        //asignamos el primer informe
        this.informe=[x[0]];
        this.changeInf([x[0]]);

      }

    }
  };
</script>
